import React, { FC } from 'react';
import { formatDateTimeUTC } from 'app/utils/date';
import { Requirement } from 'types/Requirement';
import { Checkbox, Tooltip } from '@kontentino/ui';
import clsx from 'clsx';

type Props = {
  isLoading?: boolean;
  requirement: Requirement;
  onClick: () => void;
  isDisabled?: boolean;
};

const PostRequirementView: FC<Props> = ({
  requirement,
  isLoading,
  isDisabled,
  onClick,
}) => {
  const checkboxId = `requirement${requirement.id}}`;
  function getTooltip() {
    if (requirement.who_changed_date && requirement.who_changed_name) {
      const dateTime = formatDateTimeUTC(requirement.who_changed_date);

      return `Changed by ${requirement.who_changed_name} on\u00A0${dateTime}`;
    }

    return null;
  }

  return (
    <div className="tw-my-3 tw-flex tw-items-start tw-justify-start tw-gap-2">
      <Tooltip content={getTooltip()} placement="left">
        <div>
          <Checkbox
            id={checkboxId}
            disabled={isLoading || isDisabled}
            checked={requirement.checked}
            onChange={isLoading ? undefined : onClick}
            size="small"
          />
        </div>
      </Tooltip>
      <label
        htmlFor={checkboxId}
        className={clsx(
          'tw-min-w-0 tw-cursor-pointer tw-break-all tw-text-md tw-text-grayscale-190',
          {
            'tw-text-grayscale-50 tw-line-through': requirement.checked,
          },
        )}
      >
        {requirement.text}
      </label>
    </div>
  );
};

export default PostRequirementView;
